import { useState, useEffect } from 'react';
import { useRoutes } from "react-router-dom";
import routeManager from "@/routers/routeManager";

// 动态路由渲染组件 支持静态和动态两种模式  静态模式：动态模式：
const DynamicRouter = () => {
    const [routeState, setRouteState] = useState(() => ({
        routes: routeManager.getRoutes(),
        loading: routeManager.isLoading()
    }));

    useEffect(() => {
        // 订阅路由变化
        const unsubscribe = routeManager.subscribe(({ routes, loading }) => {
            setRouteState({ routes, loading });
        });

        return unsubscribe;
    }, []);

    const { routes, loading } = routeState;

    // 使用 useRoutes 渲染路由（必须在所有条件判断之前调用）
    const element = useRoutes(routes || []);

    // 加载中显示
    if (loading) {
        return (
            <div style={{
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '16px',
                color: '#666'
            }}>
                加载路由配置...
            </div>
        );
    }

    // 路由未加载完成
    if (!routes) {
        return (
            <div style={{
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '16px',
                color: '#ff4d4f'
            }}>
                路由加载失败
            </div>
        );
    }

    // 返回渲染的路由
    return element;
};

export default DynamicRouter;
